/* eslint-disable
 no-eq-null,
 no-loop-func,
 */
import $ from 'jquery'
import angular from 'angular'
import _ from 'lodash'

export default communityCtrl

/** @ngInject */
function communityCtrl($scope, $rootScope, $state, $window, $uibModal, $stateParams, PermPermissionStore, DeviceChecker,
                       ApiService, Community, gaEventsService, ContractService, ErrorCatcher, userCommunityService, LandingPageLink) {
    $scope.questionIsFocused = false
    $scope.userCommunityInfo = {}
    $scope.mostActiveUsers = {}
    $scope.topicMessages = {}
    $scope.userChatsCount = 0
    $scope.userNotificationsCount = 0
    $scope.isMobile = DeviceChecker.isMobile
    $scope.isClient = false
    $scope.self = $scope
    $scope.state = $state
    $scope.gaEventsService = gaEventsService
    $scope.openContactForm = !_.isEmpty($stateParams.contact)
    $scope.offerPageLink = `${LandingPageLink[$window.location.hostname]}/offre-cagnotte-renouvelable/`

  // This is a callback called in the feature directive to add the state name in the state
  // object returned by Plüm's API
  // First let's create an object whose keys are the URLs of the app and whose values are
  // the corresponding state name
    const stateURLs = $state.get().reduce(((result, item) => {
        const key = `/#${item.url}`
        result[key] = item.name
        return result
    }), {})

    $scope.logout = () => $state.go('logout', {}, { reload: true })

    $scope.isActive = (state) => $state.is(state)

    $scope.hasParentState = (parent) => {
        return $state.current.parent != null ? $state.current.parent.includes(parent) : undefined
    }

    $scope.search = function (searchValue) {
        const param = window.encodeURIComponent(searchValue)
        $window.location.href = `/communaute/search/${param}?in=titlesposts`
    }

    $scope.focusQuestionInput = function (bool) {
        $scope.questionIsFocused = bool
        return $scope.$evalAsync()
    }

    $scope.addStateName = (scope, states) => {
    // Next let's get the state name from the URL. If the URL is not found, redirect to landing page
        scope.activeBurgerMenu = states.map((state) => {
            state.stateName = stateURLs[state.url]
            if (state.stateName === undefined) {
                console.error(`No state found for URL ${state.url}`)
                state.stateName = 'landing'
            }
            return state
        })
    }

    $scope.getHeaderHeight = function () {
        let headerHeight = 0
        for (const header of Array.from(angular.element('.stickBelow'))) {
            headerHeight += header.getBoundingClientRect().height
        }
        return headerHeight
    }

    $scope.getCurrentStateInfo = function (scope, states) {
        const findCurrentStateLabel = function (currentStateUrl) {
            const stateLabel = states.filter((state) => state.url === (`/#${currentStateUrl}`))
            if (stateLabel.length === 0) {
                return states[0].label
            }
            return stateLabel[0].label
        }
        scope.activeBurgerMenu = findCurrentStateLabel($state.current.url)

        return $rootScope.$on('$stateChangeSuccess', (event, toState) => {
            scope.activeBurgerMenu = findCurrentStateLabel(toState.url)
        })
    }

    $scope.openContactModal = function () {
        const openContactModal = $uibModal.open({
            animation: true,
            controller: 'contactModalCtrl',
            template: require('../contactModal/contactModal.jade')(),
            resolve: {
                contractSelected(ApiService, PermPermissionStore) {
                    return __guard__(PermPermissionStore.getStore().client, (x) => x.validatePermission()
                    .then(() => {
                        return ApiService.fetchUserInfo()
                        .then((response) => {
                            if (response.contractSelected) {
                                return response.contractSelected
                            }
                            if (response.contracts.length > 0) {
                                return response.contracts[0]
                            }
                        })
                    }))
                    .catch(() => ({}))
                },
                userInfo(ApiService) {
                    return __guard__(PermPermissionStore.getStore().client, (x) => x.validatePermission()
                    .then(() => ApiService.fetchUserInfo())
                    .catch(() => ({})))
                },
            },
        })
        return openContactModal.closed.then(() => $state.go($state.$current.self.name, { contact: undefined }, { notify: false }))
    }

    $scope.openSubscriptionModal = () => {
        $uibModal.open({ animation: true, component: 'subscriptionModal' })
    }

    $scope.redirectOnClick = () => {
        ApiService.fetchUserInfo().then((userInfo) => {
            $state.go(ContractService.getMyAccountStatusFromContract(_.get(userInfo, 'contractSelected')))
        }).catch((error) => {
            if (error.message !== 'transition prevented') {
                ErrorCatcher.catchError(error)
            }
        })
    }

    $rootScope.$on('$stateChangeStart', () => {
        __guard__(PermPermissionStore.getStore().client, (x) => x.validatePermission()
        .then(() => {
            $scope.isClient = true
        }))
    })

    const activate = function () {
        __guard__(PermPermissionStore.getStore().client, (x) => x.validatePermission()
        .then(() => {
            $scope.isClient = true
        }))

        __guard__(PermPermissionStore.getStore().user, (x) => x.validatePermission()
        .then(() => userCommunityService.fetchCommunityInfo()))
        .then(() => {
            $scope.userCommunityInfo = userCommunityService.getUserCommunityInfo()
            $scope.userChatsCount = userCommunityService.getChatsCount()
            $scope.userNotificationsCount = userCommunityService.getNotificationsCount()
        })

        Community.getMostActiveUsers().$promise
        .then((response) => {
            if (response.users) {
                $scope.mostActiveUsers = response.users
            }
        })
        .catch(ErrorCatcher.catchErrorWithoutRedirect)

        Community.getOnlineUsers().$promise
        .then((response) => {
            if (response.users) {
                $scope.onlineUsers = response.users
            }
        })
        .catch(ErrorCatcher.catchErrorWithoutRedirect)

        Community.getUsers().$promise
        .then((response) => {
            if (response.users) {
                $scope.recentlyJoinedUsers = response.users
            }
        })
        .catch(ErrorCatcher.catchErrorWithoutRedirect)

        Community.getTrendingTopics().$promise
        .then((response) => {
            for (const topic of Array.from(response.topics)) {
                if (!topic.teaser) {
                    Community.getTopic({ id: topic.tid }).$promise
                    .then((post) => {
                        $scope.topicMessages[post.tid] = post.posts[0].content
                    })
                    .catch(ErrorCatcher.catchErrorWithoutRedirect)
                }
            }
            $scope.topics = response.topics
        })
        .catch(ErrorCatcher.catchErrorWithoutRedirect)

        Community.getTrendingFaq().$promise
        .then((response) => {
            const faqCategories = response.children
            const hasPosts = (element) => element.posts.length > 0
            const newFaqCat = faqCategories.filter(hasPosts)
            newFaqCat.sort((x, y) => y.posts[0].timestamp - x.posts[0].timestamp)
            const postCount = {}
            for (let i = 0, end = newFaqCat.length, asc = end >= 0; asc ? i < end : i > end; asc ? i += 1 : i -= 1) {
                postCount[newFaqCat[i].cid] = {}
                newFaqCat[i].messageCount = postCount[newFaqCat[i].cid]
                const postId = newFaqCat[i].posts[0].topic.slug.split('/')
                Community.getTopic({ id: postId[0] }).$promise
                .then((response) => {
                    postCount[response.cid].msgCount = response.postcount
                })
                .catch(ErrorCatcher.catchErrorWithoutRedirect)
            }

            $scope.faqRecentCats = newFaqCat
        })
        .catch(ErrorCatcher.catchErrorWithoutRedirect)

        Community.getLastBlogPosts().$promise
        .then((response) => {
            const blogTopics = response.topics
            const retrieveId = (element) => element.tid
            const blogTopicsId = blogTopics.map(retrieveId)
            const blogPosts = []
            for (let i = 0, end = blogTopicsId.length, asc = end >= 0; asc ? i < end : i > end; asc ? i += 1 : i -= 1) {
                Community.getTopic({ id: blogTopicsId[i] }).$promise
                .then((response) => {
                    let postContent = response.posts[0].content

                    const dom = document.implementation.createHTMLDocument('temp')
                    dom.documentElement.innerHTML = postContent

                    const postImg = $('img', dom).get(0)
                    const postImgUrl = $(postImg).attr('src')
                    response.posts[0].imgUrl = postImgUrl

                    let text = $(dom).text()
                    if (text && (text.length > 160)) {
                        const textProv = text.substr(0, 159)
                        const indexTextDef = textProv.lastIndexOf(' ')
                        text = textProv.substr(0, indexTextDef)
                    }

                    postContent =
                { text }
                    response.posts[0].postText = postContent

                    return blogPosts.push(response)
                })
                .catch(ErrorCatcher.catchErrorWithoutRedirect)
            }
            $scope.actuPosts = blogPosts
        })
        .catch(ErrorCatcher.catchErrorWithoutRedirect)

        if ($scope.openContactForm) {
            $scope.openContactModal()
        }
    }

    return activate()
}

function __guard__(value, transform) {
    return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined
}



// WEBPACK FOOTER //
// ./src/states/community/community.js